import { Modal } from "antd";
import React from "react";
import CheckSuccess from "../assets/Icons/CheckSuccess";
import InfoWarning from "../assets/Icons/InfoWarning";
import { ReactComponent as InfoWarning2 } from "../assets/Icons/InfoWarning2.svg";
import WaitingIcon from "../assets/Icons/WaitingIcon";
import IconError from "../assets/Icons/Error";

interface SuccessModalConfig {
	title: string;
	subtitle?: string | React.ReactNode;
	onOk?: () => void;
	afterClose?: () => void;
	onCancel?: () => void;
	danger?: boolean;
	okText?: string;
	cancelText?: string;
	cancelButtonPropsStyle?: React.CSSProperties;
	icon?: React.ReactNode | boolean;
	isWaiting?: boolean;
	duration?: number;
}
export const successModal = (config: SuccessModalConfig | string, subtitle?: string | React.ReactNode) => {
	if (typeof config === "string") {
		var renderTitle = config;
		var renderSubtitle = subtitle;
		var onOk = undefined;
		var onCancel = undefined;
		var afterClose = undefined;
	} else {
		renderTitle = config.title;
		renderSubtitle = config.subtitle;
		onOk = config.onOk;
		onCancel = config.onCancel;
		afterClose = config.afterClose;
	}

	const modal = Modal.success({
		width: 520,
		closable: true,
		maskClosable: true,
		icon: (
			<div style={{ textAlign: "center" }}>
				{(config as SuccessModalConfig).isWaiting ? <WaitingIcon /> : <CheckSuccess />}
			</div>
		),
		title: renderTitle,
		content:
			typeof renderSubtitle == "string" ? (
				<p className="text-gray">{renderSubtitle}</p>
			) : renderSubtitle ? (
				renderSubtitle
			) : undefined,
		okButtonProps: { disabled: true, style: { display: "none" } },
		onCancel: onCancel ?? onOk,
		afterClose,
	});

	if ((config as SuccessModalConfig).duration) {
		setTimeout(() => {
			modal.destroy();
		}, (config as SuccessModalConfig).duration);
	}
	return modal;
};

export const warningModal = (config: SuccessModalConfig | string, subtitle?: string | React.ReactNode) => {
	if (typeof config === "string") {
		var renderTitle = config;
		var renderSubtitle = subtitle;
		var onOk = undefined;
		var onCancel = undefined;
		var afterClose = undefined;
	} else {
		renderTitle = config.title;
		renderSubtitle = config.subtitle;
		onOk = config.onOk;
		onCancel = config.onCancel;
		afterClose = config.afterClose;
	}
	return Modal.warning({
		width: 520,
		closable: true,
		maskClosable: true,
		icon: (
			<div style={{ textAlign: "center" }}>
				<InfoWarning />
			</div>
		),
		title: renderTitle,
		content:
			typeof renderSubtitle == "string" ? (
				<p className="text-gray">{renderSubtitle}</p>
			) : renderSubtitle ? (
				renderSubtitle
			) : undefined,
		okButtonProps: { disabled: true, style: { display: "none" } },
		onCancel: onCancel ?? onOk,
		afterClose,
	});
};

export const errorModal = (config: SuccessModalConfig | string, subtitle?: string | React.ReactNode) => {
	if (typeof config === "string") {
		var renderTitle = config;
		var renderSubtitle = subtitle;
		var onOk = undefined;
		var onCancel = undefined;
		var afterClose = undefined;
	} else {
		renderTitle = config.title;
		renderSubtitle = config.subtitle;
		onOk = config.onOk;
		onCancel = config.onCancel;
		afterClose = config.afterClose;
	}
	return Modal.error({
		width: 520,
		closable: true,
		maskClosable: true,
		icon: (
			<div style={{ textAlign: "center" }}>
				<IconError />
			</div>
		),
		title: renderTitle,
		content:
			typeof renderSubtitle == "string" ? (
				<p className="text-gray">{renderSubtitle}</p>
			) : renderSubtitle ? (
				renderSubtitle
			) : undefined,
		okButtonProps: { disabled: true, style: { display: "none" } },
		onCancel: onCancel ?? onOk,
		afterClose,
	});
};

export const confirmModal = (config: SuccessModalConfig | string, subtitle?: string | React.ReactNode) => {
	if (typeof config === "string") {
		var renderTitle = config;
		var renderSubtitle = subtitle;
		var onOk = undefined;
		var danger = undefined;
		var okText = undefined;
		var cancelText = undefined;
		var onCancel = undefined;
		var afterClose = undefined;
		var cancelButtonPropsStyle = undefined;
		var icon = undefined;
	} else {
		renderTitle = config.title;
		renderSubtitle = config.subtitle;
		onOk = config.onOk;
		danger = config.danger;
		okText = config.okText;
		cancelText = config.cancelText;
		onCancel = config.onCancel;
		afterClose = config.afterClose;
		cancelButtonPropsStyle = config.cancelButtonPropsStyle;
		icon = config.icon;
	}
	return Modal.confirm({
		width: 520,
		icon: icon ? (
			<div style={{ textAlign: "center" }}>
				<InfoWarning2 />
			</div>
		) : null,
		closable: true,
		maskClosable: true,
		title: renderTitle,
		content:
			typeof renderSubtitle == "string" ? (
				<p className="text-gray">{renderSubtitle}</p>
			) : renderSubtitle ? (
				renderSubtitle
			) : undefined,
		okText: okText ?? (danger ? "Delete" : "Yes"),
		okButtonProps: {
			block: true,
			danger,
		},
		cancelButtonProps: {
			block: true,
			className: danger ? "" : "btn-secondary",
			danger,
			style: {
				...cancelButtonPropsStyle,
			},
		},
		cancelText: cancelText ?? (danger ? "Cancel" : "No"),
		onOk: onOk,
		onCancel: onCancel,
		afterClose,
	});
};
